<template lang="html">
    <div id="eventAnalysis"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <div style="width: 100%;height: 100%">
                <el-row style="height: 40px;line-height: 40px;margin-top: 20px">
                <el-col :span="12">
                    <span>月份</span>
                   <!-- <el-date-picker-->
<!--                            v-model="date"-->
<!--                            style="width: 150px"-->
<!--                            format="yyyy年MM月"-->
<!--                            value-format="yyyy-MM"-->
<!--                            type="month"-->
<!--                            placeholder="选择月">-->
<!--                    </el-date-picker> -->
                    <!-- <reportMonth :handleSelectInput="handleSelectInput"></reportMonth> -->
                    <reportMonth :handleSelectInput="handleSelectInput"></reportMonth>
                </el-col>
<!--                <el-col :span="6">-->
<!--                    <span>会议类型</span>-->
<!--                    <el-select v-model="campaignArray" style="width:70%" placeholder="请选择会议类型">-->
<!--                        <el-option-->
<!--                                v-for="item in campaignOptions"-->
<!--                                :key="item.key"-->
<!--                                :label="item.value1"-->
<!--                                :value="item.key">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </el-col>-->
                <el-col :span="12" v-if="isManager">
                    <div style="float: right">
                        <span style="font-size: 16px;font-weight: bold;margin-right: 10px;">辖区</span>
                        <popedom :handleSelectInput="handleSelectInputClick" :shelfData="shelfData"></popedom>
                    </div>
                </el-col>
            </el-row>
            <el-row style="margin-top: 30px">
                <span  style="margin-right: 10px;display: inline-block;width: 70px">会议类型</span>
                <el-checkbox-group style="display: inline-block" v-model="campaignArray">
                    <el-checkbox v-for="item in campaignOptions" :label="item.key" :key="item.key">{{item.value1}}</el-checkbox>
                </el-checkbox-group>
            </el-row>
                <el-row style="margin-top:20px;border-bottom: 2px dotted rgb(231, 234, 236);padding-bottom: 20px;">
                    <el-button size="small" style="background: #4EC880;border:none;color: #fff" @click.stop="searchWeekList">查询</el-button>
                    <el-button size="small" style="background: #D0021B;border:none;color: #fff" @click.stop="ResetClick">重置</el-button>
                    <el-button size="small" style="float: right;background: #4A90E2;border:none;color: #fff" icon="el-icon-upload2" @click.stop="exportDataClick">
                        导出数据
                    </el-button>
                    <el-button size="small" style="float: right;background: #FF9901;border:none;color: #fff" icon="el-icon-upload2" @click.stop="exportDetailClick">
                        导出明细
                    </el-button>
                </el-row>
            <el-row>
                <el-col>
                    <p style="font-size: 21px;color: #000;margin-bottom: 5px">{{yearsDate}}</p>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="7">
                    <el-col style="margin: 10px 0">
                        <el-col :span="8">
                            <span style="font-size: 14px;color: #909399">发起场次</span>
                        </el-col>
                        <el-col :span="14">
                            <span style="font-size: 16px;color: #9B9B9B;font-weight: bold">{{initiateSession+'场'}}</span>
                        </el-col>
                    </el-col>
<!--                    <el-col style="margin: 10px 0" v-if="this.$store.getters.getUser.role == 'manager' ? false : true">-->
<!--                        <el-col :span="8">-->
<!--                            <span style="font-size: 14px;color: #909399">执行场次</span>-->
<!--                        </el-col>-->
<!--                        <el-col :span="14">-->
<!--                            <span style="font-size: 16px;color: #9B9B9B;font-weight: bold">{{performSession+'场'}}</span>-->
<!--                        </el-col>-->
<!--                    </el-col>-->
                    <el-col style="margin: 10px 0">
                        <el-col :span="8">
                            <span style="font-size: 14px;color: #909399">涉及机构数</span>
                        </el-col>
                        <el-col :span="14" v-if="type==='ENDPOINT'">
                            <span style="font-size: 16px;color: #9B9B9B;font-weight: bold">{{institutionsNum+'家'}}</span>
                            <span v-for="(item,j) in  institutionList"  style="background: #4A90E2;color: #fff;border-radius:5px;display: inline-block;margin:5px 5px;padding:5px;">{{item.institution_name}}</span>
                        </el-col>
                        <el-col :span="14" v-else>
                            <span style="font-size: 16px;color: #9B9B9B;font-weight: bold">{{institutionsNum+'家'}}</span>
                        </el-col>
                    </el-col>
                    <el-col style="margin: 10px 0" class="InviteCustomers">
                        <el-col :span="8">
                            <span style="font-size: 14px;color: #909399">邀请客户</span>
                        </el-col>
                        <el-col :span="14">
                            <span style="width: calc(100% - 50px);display: inline-block">
                                <el-progress :text-inside="true" :show-text="false" color="#81D8D1" stroke-linecap="butt" :stroke-width="20" :percentage="invitationPercentage"></el-progress>
                            </span>
                            <span style="color:#FF9901;float: right">{{customerNum+'人'}}</span>
                        </el-col>
                    </el-col>
                    <el-col style="margin: 10px 0" class="actualParticipation">
                        <el-col :span="8">
                            <span style="font-size: 14px;color: #909399">实际参会客户</span>
                        </el-col>
                        <el-col :span="14">
                            <span style="width: calc(100% - 50px);display: inline-block">
                                <el-progress :text-inside="true" :show-text="false" color="#81D8D1" :stroke-width="toAttendNum>0 ? 100 : 0" :percentage="invitationPercentage1"></el-progress>
                            </span>
                            <span style="color:#FF9901;float: right">{{toAttendNum+'人'}}</span>
<!--                            <p style="margin:0;float: right;font-size: 9px;color: #4A90E2;margin-right: 50px;">邀请：60人  计划外：40人</p>-->
                        </el-col>
                    </el-col>

                </el-col>
                <el-col :span="1" style="border: 1px transparent solid;">
                    <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 50px auto"></div>
                </el-col>
                <el-col :span="7" >
                    <div >
                        <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
                        <div id="main1" style="width:100%;height: 250px;text-align: center"></div>
                    </div>
                </el-col>
                <el-col :span="1" style="border: 1px transparent solid;">
                    <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 50px auto"></div>
                </el-col>
                <el-col :span="7" >
                    <div >
                        <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
                        <div id="main2" style="width:100%;height:250px;text-align: center"></div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <p style="font-size: 18px;color: #4A90E2;text-align: center">数据汇总</p>
                </el-col>
                <el-col :span="8">
                    <p style="font-size: 18px;color: #4A90E2;text-align: center">参会客户覆盖科室</p>
                </el-col>
                <el-col :span="8">
                    <p style="font-size: 18px;color: #4A90E2;text-align: center">参会客户等级占比</p>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px" v-show="type==='ENDPOINT'">
                <el-col >
                    <p style="margin:0;">
                        <img style="display: inline-block;float: left;" src="../../../assets/images/meeting-icon.png"/>
                        <span style="font-size: 20px;color: #4A90E2;float: left;margin-left: 20px;">本辖区发起的会议</span>
                    </p>
                </el-col>
                <el-col>
                    <el-table
                            :data="theJurisdiction"
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                label="序号"
                                sortable
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="activity_date"
                                label="日期"
                                sortable
                                width="150">
                        </el-table-column>
                        <el-table-column
                                prop="campaign_name"
                                sortable
                                label="名称">
                        </el-table-column>
                        <el-table-column
                                prop="campaign_type_name"
                                sortable
                                label="会议类型">
                        </el-table-column>
                        <el-table-column
                                prop="planned_expense"
                                sortable
                                label="计划会议费用">
                        </el-table-column>
                        <el-table-column
                                prop="planned_participants"
                                sortable
                                label="计划参会人数">
                        </el-table-column>
                        <el-table-column
                                prop="invited"
                                sortable
                                label="邀请客户数">
                        </el-table-column>
                        <el-table-column
                                prop="attended"
                                sortable
                                label="实际参会客户数">
                        </el-table-column>
                    </el-table>
                </el-col>
                <!--                <el-col style="margin-top:20px">-->
                <!--                    <p style="margin:0;">-->
                <!--                        <img style="display: inline-block;float: left;" src="../../../assets/images/meeting-icon.png"/>-->
                <!--                        <span style="font-size: 20px;color: #4A90E2;float: left;margin-left: 20px;">上级辖区发起的会议</span>-->
                <!--                    </p>-->
                <!--                </el-col>-->
                <!--                <el-col>-->
                <!--                    <el-table-->
                <!--                            :data="preJurisdiction"-->
                <!--                            style="width: 100%">-->
                <!--                        <el-table-column-->
                <!--                                type="index"-->
                <!--                                label="序号"-->
                <!--                                sortable-->
                <!--                                width="50">-->
                <!--                        </el-table-column>-->
                <!--                        <el-table-column-->
                <!--                                prop="territory_name"-->
                <!--                                label="上级辖区"-->
                <!--                                sortable-->
                <!--                                width="180">-->
                <!--                        </el-table-column>-->
                <!--                        <el-table-column-->
                <!--                                prop="campaigns"-->
                <!--                                sortable-->
                <!--                                label="发起场次">-->
                <!--                        </el-table-column>-->
                <!--                        <el-table-column-->
                <!--                                prop="invited_institutions"-->
                <!--                                sortable-->
                <!--                                label="涉及机构数">-->
                <!--                        </el-table-column>-->
                <!--                        <el-table-column-->
                <!--                                prop="invited_hcps"-->
                <!--                                sortable-->
                <!--                                label="邀请的客户数">-->
                <!--                        </el-table-column>-->
                <!--                        <el-table-column-->
                <!--                                prop="attended_hcps"-->
                <!--                                sortable-->
                <!--                                label="实际参会客户数">-->
                <!--                        </el-table-column>-->
                <!--                    </el-table>-->
                <!--                </el-col>-->
                <el-row>
                    <el-col style="margin-top:20px;width: 240px;float: left" >
                        <p style="margin:0;">
                            <img style="display: inline-block;float: left;" src="../../../assets/images/summary-icon.png"/>
                            <span style="font-size: 25px;color: #4A90E2;float: left;margin-left: 20px;">汇总</span>
                        </p>
                    </el-col>
                    <el-col style="float: left;width: calc(100% - 240px);margin-top:15px;">
                        <el-col :span="6">
                            <p style="color: #4A90E2;margin:0">发起场次</p>
                            <p style="color: #4A90E2;margin:10px 0">{{sessionNum}}</p>
                        </el-col>
                        <el-col :span="6">
                            <p style="color: #4A90E2;margin:0;margin-left: 2px">涉及机构数</p>
                            <p style="color: #4A90E2;margin:10px 2px">{{institutionsNum}}</p>
                        </el-col>
                        <el-col :span="6">
                            <p style="color: #4A90E2;margin:0;margin-left: 5px">邀请的客户数</p>
                            <p style="color: #4A90E2;margin:10px 5px">{{invitationCustomer}}</p>
                        </el-col>
                        <el-col :span="6">
                            <p style="color: #4A90E2;margin:0;margin-left: 8px">实际参会客户数</p>
                            <p style="color: #4A90E2;margin:10px 8px">{{actualParticipationNum}}</p>
                        </el-col>
                    </el-col>
                </el-row>
            </el-row>
            <el-row style="margin-top: 20px" v-show="type==='CONTAINER'">
                <el-col>
                    <p style="margin:0;">
                        <img style="display: inline-block;float: left;" src="../../../assets/images/meeting-icon.png"/>
                        <span style="font-size: 20px;color: #4A90E2;float: left;margin-left: 20px;">下级辖区发起的会议</span>
                    </p>
                </el-col>
                <el-col>
                    <el-table
                            :data="subJurisdiction"
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                label="序号"
                                sortable
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="territory_name"
                                label="下级辖区"
                                sortable
                                width="180">
                            <template slot-scope="scope">
                                {{scope.row.territory_name}}{{scope.row.staff_name?'('+scope.row.staff_name+')':''}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="campaigns"
                                sortable
                                label="发起场次">
                        </el-table-column>
                        <el-table-column
                                prop="institutions"
                                sortable
                                label="涉及机构数">
                        </el-table-column>
                        <el-table-column
                                prop="invited_hcps"
                                sortable
                                label="邀请的客户数">
                        </el-table-column>
                        <el-table-column
                                prop="attended_hcps"
                                sortable
                                label="实际参会客户数">
                        </el-table-column>
                    </el-table>
                </el-col>
                <el-col style="margin-top:20px;">
                    <p style="margin:0;">
                        <img style="display: inline-block;float: left;"  src="../../../assets/images/meeting-icon.png"/>
                        <span style="font-size: 20px;color: #4A90E2;float: left;margin-left: 20px;">本辖区发起的会议</span>
                    </p>
                </el-col>
                <el-col>
                    <el-table
                            :data="theJurisdiction"
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                label="序号"
                                sortable
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="territory_name"
                                label="本辖区"
                                sortable
                                width="180">
                            <template slot-scope="scope">
                                {{scope.row.territory_name}}{{scope.row.staff_name?'('+scope.row.staff_name+')':''}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="campaigns"
                                sortable
                                label="发起场次">
                            <template slot-scope="scope">
                                {{scope.row.campaigns?scope.row.campaigns:0}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="institutions"
                                sortable
                                label="涉及机构数">
                            <template slot-scope="scope">
                                {{scope.row.institutions?scope.row.institutions:0}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="invited_hcps"
                                sortable
                                label="邀请的客户数">
                            <template slot-scope="scope">
                                {{scope.row.invited_hcps?scope.row.invited_hcps:0}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="attended_hcps"
                                sortable
                                label="实际参会客户数">
                            <template slot-scope="scope">
                                {{scope.row.attended_hcps?scope.row.attended_hcps:0}}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
                <el-col style="margin-top:20px;">
                    <p style="margin:0;">
                        <img style="display: inline-block;float: left;" src="../../../assets/images/meeting-icon.png"/>
                        <span style="font-size: 20px;color: #4A90E2;float: left;margin-left: 20px;">上级辖区发起的会议</span>
                    </p>
                </el-col>
                <el-col>
                    <el-table
                            :data="preJurisdiction"
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                label="序号"
                                sortable
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="territory_name"
                                label="上级辖区"
                                sortable
                                width="180">
                            <template slot-scope="scope">
                                {{scope.row.territory_name}}{{scope.row.staff_name?'('+scope.row.staff_name+')':''}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="campaigns"
                                sortable
                                label="发起场次">
                            <template slot-scope="scope">
                                {{scope.row.campaigns?scope.row.campaigns:0}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="institutions"
                                sortable
                                label="涉及机构数">
                            <template slot-scope="scope">
                                {{scope.row.institutions?scope.row.institutions:0}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="invited_hcps"
                                sortable
                                label="邀请的客户数">
                            <template slot-scope="scope">
                                {{scope.row.invited_hcps?scope.row.invited_hcps:0}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="attended_hcps"
                                sortable
                                label="实际参会客户数">
                            <template slot-scope="scope">
                                {{scope.row.attended_hcps?scope.row.attended_hcps:0}}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
                <el-row>
                    <el-col style="margin-top:20px;width: 240px;float: left" >
                        <p style="margin:0;">
                            <img style="display: inline-block;float: left;" src="../../../assets/images/summary-icon.png"/>
                            <span style="font-size: 25px;color: #4A90E2;float: left;margin-left: 20px;">汇总</span>
                        </p>
                    </el-col>
                    <el-col style="float: left;width: calc(100% - 240px);margin-top:15px;">
                        <el-col :span="6">
                            <p style="color: #4A90E2;margin:0">发起场次</p>
                            <p style="color: #4A90E2;margin:10px 0">{{sessionNum}}</p>
                        </el-col>
                        <el-col :span="6">
                            <p style="color: #4A90E2;margin:0;margin-left: 2px">涉及机构数</p>
                            <p style="color: #4A90E2;margin:10px 2px">{{involvingInstitutionNum}}</p>
                        </el-col>
                        <el-col :span="6">
                            <p style="color: #4A90E2;margin:0;margin-left: 5px">邀请的客户数</p>
                            <p style="color: #4A90E2;margin:10px 5px">{{invitationCustomer}}</p>
                        </el-col>
                        <el-col :span="6">
                            <p style="color: #4A90E2;margin:0;margin-left: 8px">实际参会客户数</p>
                            <p style="color: #4A90E2;margin:10px 8px">{{actualParticipationNum}}</p>
                        </el-col>
                    </el-col>
                </el-row>

            </el-row>
        </div>
    </div>
</template>
<script>

    import navBar from '../../../components/navBar'
    import reportMonth from './reportMonth'
    import popedom from "./popedom";
    import http from '../../../APIService/http'
    import pagination from '../../../components/pagination'
    import moment from 'moment'
    import check from '../../../assets/images/check.png'
    export default {
        name: "eventAnalysis",
        data() {
            return {
                loading:false,
                type:this.$store.getters.getUser.role == 'staff'?'ENDPOINT':'CONTAINER',
                date:'',
                // date: new Date(),
                campaignArray:[],
                campaignOptions:[],
                theJurisdiction:[],
                yearsMonth:'',
                month:'',
                initiateSession:0,
                performSession:0,
                institutionsNum:0,
                customerNum:0,
                toAttendNum:0,
                invitationPercentage:0,
                invitationPercentage1:0,
                institutionArray:[],
                data:{},
                preJurisdiction:[],
                departmentArray:[],
                customerLevelArray:[],
                sessionNum:0,
                involvingInstitutionNum:0,
                invitationCustomer:0,
                actualParticipationNum:0,
                subJurisdiction:[],
                isManager:this.$store.getters.getUser.role !== 'staff',
                yearsDate:'',
                main1Chart:'',
                main2Chart:'',
                array:[],
                institutionList:[]

            }
        },
        components: {
            popedom,
            reportMonth
        },
        created () {
            this.yearsDate = moment(this.GLOBAL.date).format('YYYY年M月')

            this.getMeetingList()
            this.init()




        },
        mounted () {
            this.yearsDate = moment(this.GLOBAL.date).format('YYYY年M月')
            window.onresize = () => {
                this.main1Chart.resize()
                this.main2Chart.resize()
            }
            if(!this.isManager){
                this.getVisitCoverStaffTerritory()
            }

        },

        updated(){
        },
        methods: {
            shelfData(){
                this.init()
            },
            handleSelectInputClick(){
                this.init()
            },
            handleSelectInput(j){
                console.log(j)
                this.date = j
            },
            async getVisitCoverStaffTerritory(){
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id:user.tenant_id,
                        user_id : user.user_id,
                        month : this.GLOBAL.date,
                    }
                    http.post('/wapi/v1/getVisitCoverStaffTerritory',data).then(res=>{
                        if(res.success){
                            this.GLOBAL.territory_id = res.data

                        }
                    })
                }  catch (e) {

                }
            },
            async init(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id : user.tenant_id,
                        user_id : user.user_id,
                        role : user.role,
                        month:this.GLOBAL.date,
                        campaign_type:this.campaignArray,
                        territory_id : this.GLOBAL.territory_id
                    }

                    await http.post('/wapi/v1/getMeetingActivityInfo',data).then(res=>{
                        if (res.success === true){
                            // console.log(res.data)
                            // this.initiateSession=0
                            // this.institutionList = []
                            //
                            //
                            // this.institutionsNum = res.data.institutionArray.length
                            // this.customerNum = res.data.customerNum
                            //
                            // this.toAttendNum = res.data.toAttendNum
                            // if(this.customerNum == 0){
                            //     this.invitationPercentage = 0
                            // } if(this.toAttendNum == 0){
                            //     this.invitationPercentage1 = 0
                            // }
                            //
                            //
                            //
                            // this.theJurisdiction.forEach(item=>{
                            //     if(item.alias){
                            //         item.territory_name = item.territory_name +" ("+item.alias+")"
                            //     }
                            // })
                            // this.preJurisdiction.forEach(item=>{
                            //     if(item.alias){
                            //         item.territory_name = item.territory_name +" ("+item.alias+")"
                            //     }
                            // })
                            // this.subJurisdiction.forEach(item=>{
                            //     if(item.alias){
                            //         item.territory_name = item.territory_name +" ("+item.alias+")"
                            //     }
                            // })
                            //
                            //
                            //
                            //
                            // for(let i = 0; i < res.data.subJurTerritoryArray.length; i++) {//下级辖区
                            //     if (res.data.subJurTerritoryArray[i].campaigns) {
                            //
                            //         this.sessionNum += Number(res.data.subJurTerritoryArray[i].campaigns)
                            //     }
                            //     if(res.data.subJurTerritoryArray[i].invited_institutions){//涉及机构数
                            //         this.involvingInstitutionNum += Number(res.data.subJurTerritoryArray[i].invited_institutions)
                            //     }
                            //     if(res.data.subJurTerritoryArray[i].invited_hcps){//邀请客户数
                            //         this.invitationCustomer += Number(res.data.subJurTerritoryArray[i].invited_hcps)
                            //     }
                            //
                            //     if(res.data.subJurTerritoryArray[i].attended_hcps){//实际参会客户
                            //         this.actualParticipationNum += Number(res.data.subJurTerritoryArray[i].attended_hcps)
                            //     }
                            //
                            // }
                            // for(let i = 0; i < res.data.preJurArray.length; i++) {//上级辖区
                            //     if (res.data.preJurArray[i].campaigns) {
                            //
                            //         this.sessionNum += Number(res.data.preJurArray[i].campaigns)
                            //     }
                            //     if(res.data.preJurArray[i].invited_institutions){//涉及机构数
                            //         this.involvingInstitutionNum += Number(res.data.preJurArray[i].invited_institutions)
                            //     }
                            //     if(res.data.preJurArray[i].invited_hcps){//邀请客户数
                            //         this.invitationCustomer += Number(res.data.preJurArray[i].invited_hcps)
                            //     }
                            //
                            //     if(res.data.preJurArray[i].attended_hcps){//实际参会客户
                            //         this.actualParticipationNum += Number(res.data.preJurArray[i].attended_hcps)
                            //     }
                            //
                            // }
                            //
                            // for(let i = 0; i < res.data.theJurisdictionArray.length; i++) {//本辖区
                            //     if (res.data.theJurisdictionArray[i].campaigns) {
                            //         this.sessionNum += Number(res.data.theJurisdictionArray[i].campaigns)
                            //     }
                            //     if(res.data.theJurisdictionArray[i].invited_institutions){//涉及机构数
                            //         this.involvingInstitutionNum += Number(res.data.theJurisdictionArray[i].invited_institutions)
                            //     }
                            //     if(res.data.theJurisdictionArray[i].invited_hcps){//邀请客户数
                            //         this.invitationCustomer += Number(res.data.theJurisdictionArray[i].invited_hcps)
                            //     }
                            //
                            //     if(res.data.theJurisdictionArray[i].attended_hcps){//实际参会客户
                            //         this.actualParticipationNum += Number(res.data.theJurisdictionArray[i].attended_hcps)
                            //     }
                            //
                            // }
                            //
                            //
                            // if(!this.isManager){
                            //     this.initiateSession = res.data.initiateArr.length
                            // }else{
                            //     this.initiateSession = this.sessionNum
                            // }
                            //
                            // this.performSession = res.data.performArr.length
                            //
                            // //机构去重
                            // let obj = {};
                            //
                            // this.institutionArray = res.data.institutionArray.reduce((cur,next) => {
                            //     obj[next.institution_name] ? "" : obj[next.institution_name] = true && cur.push(next);
                            //     return cur;
                            // },[])
                            //
                            // this.institutionArray.forEach(item=>{
                            //     if(item.institution_name != null){
                            //         this.institutionList.push(item)
                            //     }
                            // })
                            this.performSession=0
                            this.institutionsNum=0
                            this.customerNum=0
                            this.toAttendNum=0
                            this.invitationPercentage=0
                            this.invitationPercentage1=0
                            this.initiateSession = 0
                            this.sessionNum = 0
                            this.invitationCustomer=0
                            this.actualParticipationNum=0
                            this.involvingInstitutionNum = 0
                            this.subJurisdiction = []
                            this.theJurisdiction = []
                            this.preJurisdiction = []
                            this.type = res.data.type
                            if(this.type === 'ENDPOINT'){
                                this.theJurisdiction = res.data.array
                                this.departmentArray = res.data.departmentArray
                                this.customerLevelArray = res.data.segmentArray
                                this.institutionList = res.data.institutionList
                                this.sessionNum = this.theJurisdiction.length
                                this.institutionsNum = this.institutionList.length
                                this.involvingInstitutionNum = this.institutionList.length
                                this.initiateSession = this.theJurisdiction.length
                                this.theJurisdiction.forEach(item=>{
                                    this.invitationCustomer += Number(item.invited)
                                    this.actualParticipationNum += Number(item.attended)
                                })
                            }else{
                                let parentObj = res.data.parentInfo.length>0? res.data.parentInfo[0]:''
                                res.data.array.forEach(item=>{
                                    if(item.initiator === 'T'||item.initiator === null||item.initiator === ''){
                                        this.theJurisdiction.push(item)
                                    }else if(item.initiator === 'F'&& res.data.parentInfo.length>0){
                                        item.territory_name = parentObj.territory_name
                                        item.staff_name = parentObj.staff_name
                                        this.preJurisdiction.push(item)
                                    }
                                    this.sessionNum += Number(item.campaigns)
                                    this.institutionsNum += Number(item.institutions)
                                    this.invitationCustomer += Number(item.invited_hcps)
                                    this.actualParticipationNum += Number(item.attended_hcps)
                                })
                                this.subJurisdiction = res.data.nextArray
                                this.subJurisdiction.forEach(item=>{
                                    this.sessionNum += Number(item.campaigns)
                                    this.institutionsNum += Number(item.institutions)
                                    this.invitationCustomer += Number(item.invited_hcps)
                                    this.actualParticipationNum += Number(item.attended_hcps)
                                })
                                this.preJurisdiction.forEach(item=>{
                                    this.performSession += Number(item.campaigns)
                                })
                                this.initiateSession = this.sessionNum
                                this.involvingInstitutionNum = this.institutionsNum
                                this.departmentArray = res.data.departmentArray
                                this.customerLevelArray = res.data.segmentArray
                            }
                            this.customerNum = this.invitationCustomer
                            this.toAttendNum = this.actualParticipationNum

                            if(this.customerNum>0||this.toAttendNum>0) {
                                if(this.customerNum>this.toAttendNum){
                                    this.invitationPercentage = 100
                                    this.invitationPercentage1 =this.toAttendNum/this.customerNum*100
                                }else{
                                    this.invitationPercentage = this.customerNum/this.toAttendNum*100
                                    this.invitationPercentage1 = 100
                                }
                            }else{
                                this.invitationPercentage = 0
                                this.invitationPercentage1 = 0
                            }
                            this.main1ChartFunction()

                            loading.close()
                        }
                    })

                }catch (e) {
                    loading.close()
                }
            },
            main1ChartFunction(){
                this.main1Chart=this.$echarts.init(document.getElementById('main1'));
                this.main1Chart.setOption({
                    series : [
                        {
                            name: '访问来源',
                            type: 'pie',    // 设置图表类型为饼图
                            radius: '50%',
                            label : {
                                normal : {
                                    formatter: '{w|{b} {d}%}\n{n|({c}人)}',
                                    rich: {
                                        w:{
                                            fontSize : 11,
                                            color:'#ff9901'
                                        },
                                        n:{
                                            color: '#999ba1',
                                            align: 'center',
                                            fontSize: 11,
                                        }

                                    }
                                }
                            },
                            data:this.departmentArray,
                            center:["50%","50%"]
                        }
                    ],
                    color:["#50e3c2","#63a9fa","#d16366","#fecfa3"]
                })
                this.main2Chart=this.$echarts.init(document.getElementById('main2'));
                this.main2Chart.setOption({
                    series : [
                        {
                            name: '访问来源',
                            type: 'pie',    // 设置图表类型为饼图
                            radius: '50%',
                            label : {
                                normal : {
                                    formatter: '{w|{b} {d}%}\n{n|({c}人)}',
                                    rich: {
                                        w:{
                                            fontSize : 11,
                                            color:'#ff9901'
                                        },
                                        n:{
                                            color: '#999ba1',
                                            align: 'center',
                                            fontSize: 11,
                                        }

                                    }
                                }
                            },
                            data:this.customerLevelArray,
                            center:["50%","50%"]
                        }
                    ],
                    color:["#50e3c2","#63a9fa","#d16366","#fecfa3"]
                })
            },
            async getMeetingList(){
                try {
                    let data={
                        user_id : this.$store.getters.getUser.user_id,
                        tenant_id : this.$store.getters.getUser.tenant_id,
                    }
                    await http.post('/wapi/WeekPlan/getMeetingList',data).then(res=>{
                        this.campaignOptions = res.data

                    })
                } catch (e) {

                }
            },
            searchWeekList(){
                console.log(this.date)
                this.GLOBAL.date = this.date
                this.yearsDate = moment(this.GLOBAL.date).format('YYYY年M月')
                this.init()
                this.main1ChartFunction()

            },
            ResetClick(){
                    this.GLOBAL.date='',
                    this.campaignArray=[]

            },
            exportDataClick(){
                if(this.type === 'ENDPOINT'){
                    if(this.theJurisdiction.length>0){
                        this.exportClick2()
                    }
                }else {
                    if(this.subJurisdiction.length>0){
                        this.exportClick1()
                    }
                    if(this.theJurisdiction.length>0){
                        this.exportClick2()
                    }
                    if(this.preJurisdiction.length>0){
                        this.exportClick3()
                    }
                }


            },
            exportClick1(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['下级辖区', '发起场次', '涉及机构数', '邀请客户数', '实际参会数']
                        const filterVal = [
                            'territory_name',
                            'campaigns',
                            'institutions',
                            'invited_hcps',
                            'attended_hcps',
                        ]
                        const list = JSON.parse(JSON.stringify(this.subJurisdiction))
                        list.forEach(item=>{
                            let str = item.staff_name ? '('+item.staff_name+')':''
                            item.territory_name = item.territory_name + str
                        })
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '会议活动分析(下级辖区)',
                            autoWidth: this.autoWidth
                        })
                    })
                    loading.close();
                } catch (err) {
                    loading.close();
                    this.error()
                }
            },
            exportClick2(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        let tHeader = []
                        let filterVal = []
                        let list = []
                        if(this.type === 'ENDPOINT'){
                            tHeader = ['日期', '名称', '会议类型', '计划会议费用', '计划参会人数','邀请客户数','实际参会客户数']
                            filterVal = [
                                'activity_date',
                                'campaign_name',
                                'campaign_type_name',
                                'planned_expense',
                                'planned_participants',
                                'invited',
                                'attended',
                            ]
                            list = this.theJurisdiction
                        }else {
                            tHeader = ['本辖区', '发起场次', '涉及机构数', '邀请客户数', '实际参会数']
                            filterVal = [
                                'territory_name',
                                'campaigns',
                                'institutions',
                                'invited_hcps',
                                'attended_hcps',
                            ]
                            list = JSON.parse(JSON.stringify(this.theJurisdiction))
                            list.forEach(item=>{
                                let str = item.staff_name ? '('+item.staff_name+')':''
                                item.territory_name = item.territory_name + str
                            })
                        }

                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '会议活动分析(本辖区)',
                            autoWidth: this.autoWidth
                        })
                    })
                    loading.close();
                } catch (err) {
                    loading.close();
                    this.error()
                }
            },
            exportClick3(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['上级辖区', '发起场次', '涉及机构数', '邀请客户数', '实际参会数']
                        const filterVal = [
                            'territory_name',
                            'campaigns',
                            'institutions',
                            'invited_hcps',
                            'attended_hcps',
                        ]
                        const list = JSON.parse(JSON.stringify(this.preJurisdiction))
                        list.forEach(item=>{
                            let str = item.staff_name ? '('+item.staff_name+')':''
                            item.territory_name = item.territory_name + str
                        })
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '会议活动分析(上级辖区)',
                            autoWidth: this.autoWidth
                        })
                    })
                    loading.close();
                } catch (err) {
                    loading.close();
                    this.error()
                }
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            exportDetailClick(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let data ={
                        user_id:this.$store.getters.getUser.user_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        role:this.$store.getters.getUser.role,
                        month:this.GLOBAL.date,
                        territory_id:this.GLOBAL.territory_id,
                    }
                    http.post('/wapi/v1/getSignDetailVisitEve',data).then(res=>{
                        if(res.success){
                            this.array = res.data
                            this.exportClickDetail()
                            loading.close()
                        }
                    })
                }catch (e) {
                    loading.close()
                }

            },
            exportClickDetail(){

                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = [ '会议编码', '发起人', '执行人', '会议类型','会议名称', '开始时间', '结束时间', '参会HCP编码','参会HCP姓名','所属科室','客户等级','所属机构编码','所属机构名称','是否计划内客户']
                        const filterVal = [
                            'activity_id',
                            'initiator_name',
                            'assistants',
                            'campaign_type_name',
                            'campaign_name',
                            'start_time',
                            'end_time',
                            'hcp_code',
                            'hcp_name',
                            'dept_name',
                            'segment_id',
                            'institution_code',
                            'institution_name',
                            'invited'
                        ]
                        const list = this.array
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '会议活动分析',
                            autoWidth: this.autoWidth
                        })
                    })

                } catch (err) {

                    this.error()
                }
            },


        },

    }
</script>

<style scoped>
    /*#eventAnalysis {*/
    /*    background: #fff;*/
    /*    padding: 0px 50px;*/
    /*    height: 100%;*/
    /*    box-sizing: border-box;*/
    /*}*/
    #eventAnalysis >>>.el-form-item__label{
        font-size: 16px;
        color: #000000;
        padding-left: 0px;
        text-align: left;
        padding-right: 40px;
    }
    #eventAnalysis >>>.el-table th{
        padding: 7px 0px;
    }
    #eventAnalysis >>>.el-table td{
        padding: 7px 0px;
    }
    #eventAnalysis >>> .el-progress-bar__outer{
        border-radius: 2px;
        height: 20px!important;
    }
    #eventAnalysis >>> .el-progress-bar__inner{
        border-radius: 2px;
    }
    .InviteCustomers >>> .el-progress-bar__outer{
        background: #fff;
        height: 20px;
    }
    .actualParticipation >>> .el-progress-bar__outer{
        /*background: #CCEEF1;*/
        background: #fff;
        height: 20px;
    }



</style>



// WEBPACK FOOTER //
// src/pages/statement/components/eventAnalysis.vue